module.exports = __webpack_public_path__ + "static/media/user-new.e365c92d.svg";